<template>
  <el-card
    class="remittances-draw-money business-handling my-card"
    :body-style="cardBody"
  >
    <el-page-header @back="$router.go(-1)" :title="$t('Back')">
      <template slot="content"
        ><span style="font-size:14px"
          >{{ $t("drawMoneyBusiness") }} /
          {{ $t("remittancesDrawMoney") }}</span
        ></template
      >
    </el-page-header>
    <div class="form-container">
      <el-divider content-position="left">{{ $t("incomeRecord") }}</el-divider>
      <el-form
        inline
        ref="queryForm"
        :model="queryForm"
        :rules="rules"
        style="height:60px;overflow:hidden;"
      >
        <el-form-item
          :label="$t('linkPhone')"
          prop="phone"
          style="margin-bottom:0"
        >
          <el-input
            size="medium"
            v-model="phoneRaw"
            @blur="$refs.queryForm.validateField('phone')"
            @input="
              queryForm.phone = (selectedDial + phoneRaw).replace(/\s/g, '')
            "
          >
            <el-select
              slot="prepend"
              v-model="selectedDial"
              style="width: 100px"
              size="medium"
              filterable
            >
              <el-option
                v-for="c in countryCodes"
                :key="c.code"
                :label="`${c.flag} ${c.dial}`"
                :value="c.dial"
              >
                <span style="float: left">{{ c.flag }} {{ c.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  c.dial
                }}</span>
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-bottom:0">
          <el-button
            size="medium"
            type="primary"
            @click="getRemittanceList('queryForm')"
            :loading="isLoading"
            >{{ $t("query") }}{{ $t("remittanceInfo") }}</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 收到汇款信息的列表 -->
      <el-card
        v-if="remittanceList"
        class="box-card remittance-information-list"
        shadow="never"
        :body-style="{ padding: '0px 20px' }"
      >
        <div slot="header" class="clearfix">
          <span>{{ $t("remittanceInfo") }}</span>
        </div>
        <el-table
          size="small"
          ref="singleTable"
          :data="remittanceList"
          @row-click="selectionChange"
          highlight-current-row
          style="width: 100%;"
          max-height="300px"
          v-loading="isCompute"
          :element-loading-text="$t('Handling fee calculation')"
          @select="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="customerName" :label="$t('Name of Remitter')">
            <template slot-scope="scope"
              >{{ scope.row.remitterName + " " + scope.row.remitterSurname }}
            </template>
          </el-table-column>
          <el-table-column
            prop="remitterPhone"
            :label="$t('linkPhone')"
          ></el-table-column>
          <el-table-column
            prop="credentialNo"
            :label="$t('The remittance voucher')"
          ></el-table-column>
          <el-table-column prop="amount" :label="$t('The remittance amount')">
            <template slot-scope="scope">
              ₣ {{ scope.row.amount.formatMoney(0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="transactionCode"
            :label="$t('Transaction no.')"
          ></el-table-column>
          <el-table-column
            prop="payServiceChargeType"
            :label="$t('Service Fee Payment Method')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.payServiceChargeType == 0">{{
                $t("remitterPayment2")
              }}</span>
              <span v-if="scope.row.payServiceChargeType == 1">{{
                $t("payeePayment2")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerName"
            :label="$t('payeeName')"
          ></el-table-column>
          <el-table-column
            prop="phone"
            :label="$t('payeePhone')"
          ></el-table-column>
        </el-table>
      </el-card>
      <el-divider content-position="left" class="update-el-divider">{{
        $t("withdrawalInfo")
      }}</el-divider>
      <el-form
        v-if="withdrawalInfo"
        ref="withdrawalInfo"
        :model="withdrawalInfo"
        :rules="rules2"
        label-position="top"
      >
        <el-input
          type="hidden"
          size="medium"
          v-model="withdrawalInfo.businessCode"
          disabled
        ></el-input>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('withdrawalAmount')" prop="amount">
              <el-input
                size="medium"
                v-model="withdrawalInfo.amount"
                disabled
                :placeholder="$t('Please select the remittance record')"
              >
                <template slot="prepend">₣</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$t('Service Fee Payment Method')"
              prop="payServiceChargeType"
            >
              <el-select
                size="medium"
                v-model="withdrawalInfo.payServiceChargeType"
                disabled
                :placeholder="$t('Please select the remittance record')"
              >
                <el-option
                  :label="$t('remitterPayment2')"
                  :value="0"
                ></el-option>
                <el-option :label="$t('payeePayment2')" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="withdrawalInfo.payServiceChargeType == 1">
            <el-form-item
              :label="$t('serviceCharge')"
              prop="serviceChargeAmount"
            >
              <el-input
                size="medium"
                v-model="withdrawalInfo.serviceChargeAmount"
                disabled
              >
                <template slot="prepend">₣</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('toBeWithdraw')">
              <el-input size="medium" :value="netWithdrawAmount" disabled>
                <template slot="prepend">₣</template>
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <transaction-tax-display
              businessCode="51"
              :transaction-amount="withdrawalInfo.amount"
            ></transaction-tax-display>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              :label="$t('idNumber')"
              prop="idCard2"
              style="margin-bottom:0"
            >
              <el-input
                size="medium"
                v-model="withdrawalInfo.idCard2"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="withdrawalInfo.businessCode != '22'">
            <el-form-item :label="$t('post')" prop="post2">
              <el-input size="medium" v-model="withdrawalInfo.post2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('remark')">
              <el-input
                size="medium"
                type="textarea"
                v-model="withdrawalInfo.remark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-button" v-if="withdrawalInfo">
      <el-button
        size="medium"
        :loading="isLoading"
        type="primary"
        @click="onSubmit('withdrawalInfo')"
        >{{ $t("submit") }}</el-button
      >
    </div>

    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="500px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import printCredentials from "@/components/printWithdrawal";
import TransactionTaxDisplay from "@/components/TransactionTaxDisplay";
import transactionInfo from "@/api/transactionInfo";
import transactionDetails from "@/api/transactionDetails";
//import manba from "@/assets/uilt/manbaDate";
export default {
  components: { printCredentials, TransactionTaxDisplay },
  data() {
    return {
      /**查询汇款记录Form */
      queryForm: {},
      remittanceList: [],
      isLoading: false,
      qrcodeParam: "",
      /**取款信息 */
      withdrawalInfo: null,

      isCompute: false,

      //回执单
      printVisible: false,
      printParam: null,
      phoneRaw: "",
      selectedDial: "+227",
      countryCodes: [
        { code: "NE", name: "Niger", flag: "🇳🇪", dial: "+227" },
        { code: "NG", name: "Nigeria", flag: "🇳🇬", dial: "+234" },
        { code: "CI", name: "Côte d'Ivoire", flag: "🇨🇮", dial: "+225" },
        { code: "SN", name: "Sénégal", flag: "🇸🇳", dial: "+221" },
        { code: "ML", name: "Mali", flag: "🇲🇱", dial: "+223" },
        { code: "BF", name: "Burkina Faso", flag: "🇧🇫", dial: "+226" },
        { code: "TD", name: "Tchad", flag: "🇹🇩", dial: "+235" },
        { code: "CM", name: "Cameroun", flag: "🇨🇲", dial: "+237" },
        { code: "GH", name: "Ghana", flag: "🇬🇭", dial: "+233" },
        { code: "TG", name: "Togo", flag: "🇹🇬", dial: "+228" },
        { code: "BJ", name: "Bénin", flag: "🇧🇯", dial: "+229" },
        { code: "GN", name: "Guinée", flag: "🇬🇳", dial: "+224" },
        { code: "FR", name: "France", flag: "🇫🇷", dial: "+33" },
        { code: "MA", name: "Maroc", flag: "🇲🇦", dial: "+212" },
        { code: "US", name: "États-Unis", flag: "🇺🇸", dial: "+1" },
      ],
    };
  },
  watch: {
    printVisible(val) {
      if (!val && this.printParam) {
        this.$router.replace({ name: "businessHandling" }).then(() => {
          this.$router.go(0);
        });
      }
    },
    phoneRaw(val) {
      this.$set(
        this.queryForm,
        "phone",
        (this.selectedDial + val).replace(/\s/g, ""),
      );
    },
    selectedDial() {
      this.$set(
        this.queryForm,
        "phone",
        (this.selectedDial + (this.phoneRaw || "")).replace(/\s/g, ""),
      );
    },
  },
  computed: {
    cascader() {
      return this.$store.state.format.cascader;
    },
    cardBody() {
      return this.$store.state.style.cardBody;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    rules() {
      return {
        idCard: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!this.phoneRaw || this.phoneRaw.trim().length < 4) {
                callback(new Error(this.$t("requiredFields")));
              } else {
                callback();
              }
            },
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        serviceChargeAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payServiceChargeType: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    rules2() {
      return {
        idCard2: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        serviceChargeAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payServiceChargeType: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    netWithdrawAmount() {
      if (!this.withdrawalInfo) return "";
      const amount = parseFloat(this.withdrawalInfo.amount || 0) || 0;
      const fee = parseFloat(this.withdrawalInfo.serviceChargeAmount || 0) || 0;
      if (!amount) return "";

      const net =
        this.withdrawalInfo.payServiceChargeType === 1 ? amount - fee : amount;

      return net > 0 ? String(net).formatMoney(0, " ") : "";
    },
  },
  created() {
    console.log("Current business code from route:", this.$route.params.code);
  },
  methods: {
    getRemittanceList(refName) {
      let _this = this;
      _this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;
        transactionInfo.getByPhoneAndIdCard({
          param: _this.queryForm,
          success: (res) => {
            if (res.code != 200) {
              _this.remittanceList = null;
              _this.$message.warning(_this.$t(res.msg));
            } else {
              let list = JSON.parse(JSON.stringify(res.data));
              _this.remittanceList = list.filter(function(l) {
                //l.withdarwMoneyCode = undefined;
                return l.amount > 0;
              });
              this.getPayeeRecords("queryForm");
            }
            _this.isLoading = false;
          },
        });
      });
    },

    getPayeeRecords(refName) {
      let _this = this;
      let p = {};
      p.phone = _this[refName].phone;

      transactionDetails.getByPhoneAndIdCard({
        param: p,
        success: (res) => {
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              const firstTransaction = res.data[0];

              this.$set(this.withdrawalInfo, "post2", firstTransaction.post);
            } else {
              // Update form fields reactively
              this.$set(this.withdrawalInfo, "post2", "");

              _this.$message.warning(_this.$t("no data"));
            }
          } else {
            // Update form fields reactively

            this.$set(this.withdrawalInfo, "post2", "");

            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },

    /**点击复选框时触发 */
    handleSelectionChange(rows) {
      setTimeout(() => {
        this.selectionChange(rows[1] || rows[0]);
      }, 50);
    },
    /**点击行触发 */
    selectionChange(row) {
      if (!row) {
        this.$set(this, "withdrawalInfo", null);
        return;
      }
      // console.log("-----selectionChange----------", row.credentialNo)
      this.$refs.singleTable.clearSelection();
      this.$refs.singleTable.toggleRowSelection(row);
      let item = JSON.parse(JSON.stringify(row));
      this.$set(this, "withdrawalInfo", item);
    },
    /**提交取款信息 */
    onSubmit(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        _this.isLoading = true;
        let param = {
          businessCode: _this.$route.params.code,
          idCard: _this[refName].idCard2,
          phone: _this.queryForm.phone,
          transactionInfoId: _this[refName].transactionInfoId,
          //withdarwMoneyCode: _this[refName].withdarwMoneyCode,
          post: _this[refName].post2,
          // _this[refName].payeeDateOfBirth = manba(_this[refName].payeeDateOfBirth).format('ymdhms')

          remark: _this[refName].remark,
        };
        transactionInfo.remittanceWithdrawals({
          param: param,
          success: (res) => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));

              _this.$set(_this, "printParam", res.data);
              _this.$set(_this, "printVisible", true);
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
            _this.isLoading = false;
          },
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.remittances-draw-money.business-handling {
  height: 100%;
  width: 100%;
  .el-card__body {
    position: relative;
    .form-container {
      position: absolute;
      top: 60px;
      bottom: 80px;
      left: 20px;
      right: 0;
      padding-right: 20px;
      overflow: auto;
    }
  }
  .el-form {
    height: auto;
  }
  .update-el-divider {
    margin-top: 40px;
  }
}
</style>

<style lang="less">
.remittances-draw-money {
  .box-card {
    margin-top: 20px;
    .clearfix {
      position: relative;
      button {
        position: absolute;
        top: -10px;
        left: 50%;
        color: @primary;
      }
    }
    .el-collapse-item__header {
      display: none;
    }
  }
  .el-table__header-wrapper tr .el-checkbox {
    display: none;
  }
}
</style>
